import React from "react";
import { Card, Typography, Box, Grid } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../utils";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import { useTheme } from "@emotion/react";

const StatCard = ({ title, value, change, color, icon }) => (
    <Card
        sx={{
            p: 3,
            borderRadius: 1,
            position: "relative",
            overflow: "hidden",
            background: `linear-gradient(135deg, ${color}55, ${color})`,
            color: "#fff",
            minHeight: 150,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        }}
    >
        {/* Background Circles */}
        <Box
            sx={{
                position: "absolute",
                width: 150,
                height: 150,
                borderRadius: "50%",
                backgroundColor: "#ffffff22",
                top: -30,
                right: -60,
            }}
        />
        <Box
            sx={{
                position: "absolute",
                width: 150,
                height: 150,
                borderRadius: "50%",
                backgroundColor: "#ffffff22",
                bottom: -75,
                right: -20,
            }}
        />

        {/* Card Content */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle1">{title}</Typography>
            <Box fontSize={24}>{icon}</Box>
        </Box>
        <Typography variant="h4" fontWeight="bold">
            {value}
        </Typography>
        <Typography variant="body2">{change}</Typography>
    </Card>
);

const DashboardCard = ({ data }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const stats = [
        {
            title: t('totalPosts'),
            value: formatPrice(data?.posts.totalPrice),
            change: formatPrice(data?.posts.totalPost),
            color: theme.palette.dashbaord.red,
            icon: <Inventory2OutlinedIcon />,
        },
        {
            title: t('expenses'),
            value: formatPrice(data?.expenses.totalAmount),
            change: "-",
            color: theme.palette.dashbaord.blue,
            icon: <AttachMoneyOutlinedIcon />,
        },
        {
            title: t('totalCome'),
            value: formatPrice(data?.totalCome),
            change: "-",
            color: theme.palette.dashbaord.green,
            icon: <TrendingUpIcon />,
        },
        {
            title: t('totalGo'),
            value: formatPrice(data?.totalGo),
            change: "-",
            color: theme.palette.dashbaord.purple,
            icon: <TrendingDownIcon />,
        },
    ];

    return (
        <Grid container spacing={2}>
            {stats.map((stat, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                    <StatCard {...stat} />
                </Grid>
            ))}
        </Grid>
    );
}

export default DashboardCard;
